<template>
  <BaseField
    ref="field"
    v-bind="attributes"
    v-on="$listeners"
  />
</template>

<script>
import BaseField from '@/components/BaseField.vue';

export default {
  name: 'FieldLogin',
  inheritAttrs: false,
  components: {
    BaseField,
  },
  props: {
    invalidValues: {
      type: Array,
      default: () => [],
    },
  },
  staticData: () => ({
    mask: {
      mask: /^[\wа-яА-ЯёЁ.-]+$/,
    },
  }),
  computed: {
    attributes() {
      return {
        type: 'text',
        label: this.$t('fields.loginLabel'),
        placeholder: this.$t('fields.loginPlaceholder'),
        maskOptions: this.mask,
        errorMessage: this.isValueInvalid
          ? this.$t('fields.loginInvalidError')
          : this.$t('fields.loginError'),
        completeValidator: this.checkIsComplete,
        required: true,
        ...this.$attrs,
      };
    },
    isValueInvalid() {
      return this.invalidValues.includes(this.$attrs.value);
    },
  },
  methods: {
    focus() {
      return this.$refs.field?.focus();
    },
    checkValidity() {
      return this.$refs.field?.checkValidity();
    },
    checkHasValue() {
      return this.$refs.field?.checkHasValue();
    },
    setErrorMessage() {
      return this.$refs.field?.setErrorMessage();
    },
    checkIsComplete(value, field) {
      if (!field.isFieldRequired && value === '') {
        return true;
      }
      if (this.isValueInvalid) {
        return false;
      }
      return value.length > 1;
    },
  },
};
</script>
